import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { forEach, keyBy, map, set } from 'lodash';
import turf from '@turf/turf';

import * as projectOps from '../../../api/Projects/project-operations';

import ProjectItemsList from '../../components/ProjectItemsList';

const INITIAL_DATE_RANGE_START = '2020-01-01';
const INITIAL_DATE_RANGE_END = new Date().toISOString().slice(0, 10);
const INITIAL_BOUNDING_BOX = [
  [-180, -90],
  [180, 90]
];

const ProjectItemsListContainer = ({ project, types, ...rest }) => {
  const [timeFilterOn, changeTimeFilterOn] = useState(false);
  const [dateRangeStart, changeRangeStart] = useState(INITIAL_DATE_RANGE_START);
  const [dateRangeEnd, changeRangeEnd] = useState(INITIAL_DATE_RANGE_END);
  const timeFilterProps = {
    changeFilterOn: changeTimeFilterOn,
    changeRangeEnd,
    changeRangeStart,
    dateRangeEnd,
    dateRangeStart,
    filterOn: timeFilterOn,
    humanValue: 'Date',
    name: 'date'
  };

  const [locationFilterOn, changeLocationFilterOn] = useState(false);
  const [boundingBox, changeBoundingBox] = useState(INITIAL_BOUNDING_BOX);
  const locationFilterProps = {
    boundingBox,
    changeBoundingBox,
    changeFilterOn: changeLocationFilterOn,
    defaultLocation: turf.getCoord(projectOps.getMapLocation(project)),
    filterOn: locationFilterOn,
    humanValue: 'Location',
    name: 'location'
  };

  const typeFilters = keyBy(
    map(types, ({ name, value, humanValue }) => ({
      filterOn: false,
      name: `type${name}`,
      value,
      humanValue
    })),
    'name'
  );
  const typeFilterProps = {
    ...typeFilters
  };
  forEach(typeFilters, ({ name }) => {
    const [filterOn, changeFilterOn] = useState(false);
    set(typeFilterProps, `${name}.filterOn`, filterOn);
    set(typeFilterProps, `${name}.changeFilterOn`, changeFilterOn);
  });
  // Con esto último hay que tener cuidado. Si vemos que peta mucho, entoncces lo ponemos como un componente con estado
  // y lo metemos todo dentro de él como está ahora en el ProjectItemsList, y puerta.

  const tagsFilterProps = {
    name: 'tags',
    tagsInFilter: []
  };

  const filterOptions = {
    tags: tagsFilterProps,
    time: timeFilterProps,
    location: locationFilterProps,
    ...typeFilterProps
  };

  return <ProjectItemsList project={project} filterOptions={filterOptions} {...rest} />;
};

ProjectItemsListContainer.defaultProps = {
  types: {}
};

ProjectItemsListContainer.propTypes = {
  project: PropTypes.object.isRequired,
  types: PropTypes.object
};
export default ProjectItemsListContainer;
